<template>
  <div>
    <!-- 资源随行的头 -->
    <div class="header">
      <div class="logoDiv">
        <img :src="navLogo" />
      </div>
      <div class="header-right-div">
        
        <ul>
            <li>
            <div class="mainMenuDiv">
              <div class="dropdownMenuDiv" @click="tohelp">
                <i class=" liIcon  iconfont icon-help"></i>
                <div class="liTxt">帮助</div>
              </div>
            </div>
          </li>
          <li style="margin-right:60px">
            <div class="mainMenuDiv">
              <el-popover placement="bottom" popper-class="download-popver" trigger="hover">
                <div class="download-box">
                  <div class="box">
                    <div class="image-box">
                      <svg-icon icon-class="uclass-logo" class="logo" />
                    </div>
                    <div class="box-title"><span class="main">优领课授课端</span>
                        <span class="min">
                        一款集成多个教学工具的Windows电脑应用，老师可以使用优领课来辅助教学。
                        </span>
                    </div>
                    <div class="box-bot">
                      <el-button @click="download('pc')">下载</el-button>
                    </div>

                  </div>
<!--                  <div class="right-border"> </div>-->
<!--                  <div class="box">-->
<!--                    <div class="image-box">-->
<!--                      <svg-icon icon-class="uclass-logo" class="logo" />-->
<!--                    </div>-->
<!--                    <div class="box-title"><span class="main">优领课同步助手</span> <span class="min">一款帮助老师同步电脑课件至任意其他设备的轻量级Windows电脑应用。</span> </div>-->
<!--                    <div class="box-bot">-->
<!--                      <el-button @click="download('res')">下载</el-button>-->
<!--                    </div>-->

<!--                  </div>-->
                  <div class="right-border"> </div>
                  <div class="box app-qrcode">
                    <div class="image-box">
                      <vue-qr style="left:60px" :text="getQrUrl" :size="60" :margin="0"></vue-qr>
                    </div>
                    <div class="box-title"><span class="main">优领课授课助手</span>
                      <span class="min">
                        一款帮助老师快速同步、展示和控制大屏课件的手机应用。
                      </span>
                    </div>
                    <div class="box-bot" style="font-size:12px;line-height:35px"> 请扫码安装 </div>
                    <div class="tip">
                      *仅支持3.20版本及以上优领课授课端使用
                    </div>
                  </div>
                </div>
                <div class="dropdownMenuDiv" slot="reference">
                  <i class=" liIcon  iconfont icon-download"></i>
                  <div class="liTxt">客户端下载</div>
                </div>
              </el-popover>
            </div>
          </li>
        
          <li>
            <div class="mainMenuDiv">
              <el-popover placement="bottom-end" popper-class="common-popver user-info-popover" trigger="hover">
                <div class="user-info-div">
                  <div class="user-base-info">
                    <div class="user-base-info-inner">
                      <div class="user-avatar-div">
                        <ucAvatar class="rs-user" size="medium" :sex="info.userInfo.sex + ''" :src="info.userInfo.picStr"></ucAvatar>
                      </div>
                      <div class="user-info-right">
                        <div class="user-name-div" :title="info.userInfo.name"><span class="user-name-span">{{info.userInfo.name}}</span></div>
                        <div class="user-phone-div"><img :src="getPhoneImage" /><span class="user-phone-span">{{info.userInfo.phone}}</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="user-usage-info">
                    <div class="use-date-div">已用天数<span class="use-date-span">{{formatUseDate(info.userInfo.useDate)}}</span></div>
                    <div class="use-stage-div">
                      容量空间
                      <el-progress class="use-stage-progress" :show-text="false" :stroke-width="12" :percentage="getUserStagePertage"></el-progress>
                      <span class="use-stage-span" :title="formatFileSize(info.userInfo.usedStorage)+ '/' + formatFileSize(info.userInfo.maxStorage)">{{formatFileSize(info.userInfo.usedStorage)}}/{{formatFileSize(info.userInfo.maxStorage)}}</span>
                    </div>
                  </div>
                  <span class="user-split"></span>
                  <div class="user-logout-div"><span class="user-logout-span" @click="logout">退出帐号</span></div>
                </div>
                <div class="dropdownMenuDiv user" slot="reference">
                  <div class="liTxt">{{info.userInfo.name}}</div> <i class=" iconfont icon-arrow-down mini"></i>
                </div>
              </el-popover>

            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import vueQr from 'vue-qr'
import navLogo from '../../styles/nav/nav-logo.svg'
import ucAvatar from '../CustomAvator/avatar-index'
import { formatFileSize } from "../../utils/fileUtil";  //自定义头像
import phoneImage from '../../assets/images/Nav/resource-nav-phone.svg'
export default {
  props: {
    menus: {
      type: Array,
      default: function () {
        return [];
      }
    },
    info: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userName: {
      type: String,
      default: function () {
        return '';
      }
    }
  },
  components: {
    vueQr, ucAvatar
  },
  data() {
    return {
      navLogo: navLogo,
      rsUserShow: false
    };
  },
  mounted() {
    //console.log(this.info)
  },
  computed: {
    getPhoneImage() {
      return phoneImage;
    },
    getUserStagePertage() {
      if (this.info && this.info.userInfo && this.info.userInfo.maxStorage) {
        return (this.info.userInfo.maxStorage && this.info.userInfo.usedStorage >= this.info.userInfo.maxStorage ? 100 : this.info.userInfo.usedStorage / this.info.userInfo.maxStorage * 100);
      }
      return 0;
    },
    getQrUrl() {
      if (this.info && this.info.qrUrl) {
        return this.info.qrUrl;
      }
      return '';
    }
  },
  watch: {
  },
  methods: {
    logout() {
      this.$confirm("确定要退出登录？","确认退出").then(() => {
        this.$emit('logout');
      });
    },
    toUserCenter() {
      this.$emit('userCenter')
    },
    tohelp() {
      window.open(this.info.helpUrl, "_blank")
    },
    download(type) {
      console.log(type)
      if (type == 'res') {
        window.open(this.info.resdownUrl, "_self")
      } else if (type == 'pc') {
        window.open(this.info.pcdownUrl, "_self")
      }
    },
    formatFileSize(fileSize){
      if(typeof(fileSize) != "undefined" && fileSize != '-') {
        return formatFileSize(fileSize, 2);
      }
      return '-';
    },
    formatUseDate(value){
      if(typeof(value) != "undefined"){
        if(value <= 0){
          return '1天';
        }else if(value >= 365){
          return parseInt(value/365) + '年' + parseInt(value%365) + '天';
        }else{
          return value + '天';
        }
      }
      return '-';
    },
  },
  directives: {
  },
  filters: {
  },
};
</script>

<style lang="scss" scoped >
.header {
  height: 44px;
  line-height: 44px;
  width: 100%;
  background: linear-gradient(
    145deg,
    rgba(34, 39, 48, 1) 0%,
    rgba(42, 51, 68, 1) 100%
  );
}
.header .logoDiv {
  float: left;
  height: 44px;
  width: 220px;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 40px;
    bottom: 0;
    margin: auto;
  }
}
.header .header-right-div {
  float: right;
  height: 44px;
  line-height: 44px;
  margin-right: 16px;
}
.header ul {
  margin-top: 0px;
  list-style-type: none;
  li {
    cursor: pointer;
    height: 44px;
    line-height: 44px;
    float: left;
    color: #ffffff;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0px 10px 0px 10px;
    .liTxt {
      max-width: 100px;
      margin-right: 8px;
      height: 44px;
      line-height: 44px;
      float: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.header li .liIcon {
  float: left;
  margin: 0px 5px 0px 0px;
}
.header .dropdownMenuDiv {
  height: 44px;
}
.header .dropdownMenuDiv.user {
  padding-right: 56px;
}
.header .dropdownMenuDiv:hover {
  color: #20ccc6;
  -webkit-transition: all 0.15s;
  -moz-transition: all 0.15s;
  -ms-transition: all 0.15s;
  -o-transition: all 0.15s;
  transition: all 0.15s;
  // border-bottom: 1px solid #20ccc6;
}

.right-border {
  display: inline-block;
  border-left: 1px solid #edf5fc;
  text-align: center;
  height: 165px;
  margin-top: 20px;
}

.download-box {
    display: flex;
    height: 220px;
  .box {
    width: 270px;
    display: inline-block;
    text-align: center;
    vertical-align: top;
    .box-title {
       height: 50px;
       margin-bottom: 30px;
      span {
        display: block;
        word-wrap: break-word;
        line-height: 16px;
        text-overflow: ellipsis;
        white-space: normal;
        font-size: 12px;
      }
      .main {
        color: #303233;
      }
      .min {
        color: #909599;
        padding: 0 15px;
        width: 220px;
        text-align: center;
        margin: 15px auto 0 auto;
      }
    }

  }
  .image-box {
    text-align: center;
    padding-top: 16px;
    position: relative;
    height: 70px;
  }
  .logo {
    width: 60px;
    height: 60px;
  }
}

.user-info-div {
  width: 280px;
  height: 220px;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  .user-base-info {
    height: 86px;
    width: 100%;
    display: inline-block;
    background-image: url("../../assets/images/Nav/resource-nav-bg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    border-radius: 4px 4px 0px 0px;
    .user-base-info-inner {
      margin: 16px 0px 0px 24px;
      .user-avatar-div {
        display: inline-block;
        vertical-align: middle;
        width: 54px;
        height: 54px;
        background: #20CCC6;
        border-radius: 50%;
        text-align: center;
      }
      .user-info-right {
        margin-left: 12px;
        display: inline-block;
        vertical-align: middle;
        .user-name-div {
          font-size: 14px;
          font-weight: 700;
          color: #FFFFFF;
          .user-name-span{
            display: inline-block;
            max-width: 150px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .user-phone-div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          font-weight: 700;
          color: #FFFFFF;
          margin-top: 6px;
          .user-phone-span {
            margin-left: 4px;
          }
        }
      }
    }
  }
  .user-usage-info {
    width: 100%;
    .use-date-div {
      margin-top: 20px;
      margin-left: 20px;
      font-size: 12px;
      color: rgba(48, 50, 51, 1);
      font-weight: 400;

      .use-date-span {
        margin-left: 16px;
      }
    }
    .use-stage-div {
      margin-top: 12px;
      margin-left: 20px;
      font-size: 12px;
      color: rgba(48, 50, 51, 1);
      font-weight: 400;
      .use-stage-progress {
        width: 84px;
        display: inline-block;
        margin-left: 16px;
      }
      .use-stage-span {
        margin-left: 8px;
        display: inline-block;
        vertical-align: middle;
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .user-split {
    width: 239px;
    height: 1px;
    display: inline-block;
    background: #E6EDF5;
    margin: 24px 0px 0px 20px;
  }
  .user-logout-div {
    width: 100%;
    text-align: center;
    line-height: 1;
    margin-top: 8px;
    .user-logout-span {
      font-weight: 400;
      font-size: 12px;
      color: rgba(48, 50, 51, 1);
      cursor: pointer;
      &:hover{
        color: #20CCC6;
      }
    }
  }
}
.app-qrcode{
  .tip{
    font-size: 12px !important;
    color: #258ce6 !important;;
  }
}
</style>
<style lang="scss">
@import "./ResourceNav.scss";
</style>